import { get, isNumber, round } from 'lodash'
import { FieldList, StationGeometry } from '@/models/InitData'
import { Present } from '@/models/Present'

/**
 * 現在値レベルの表示フォーマットを整える
 * @param present 現在値情報（presentStoreのpresent）
 * @param field フィールド（camelに変換した後）
 * @param station 局情報(表示したい局)
 * @param fieldList 初期情報APIのフィールドリスト
 * @returns 表示する文字列
 */
export const displayPresentLevel = (
  present: {
    [key in string]: Present
  },
  field: string,
  station: StationGeometry,
  fieldList: FieldList
) => {
  const fieldInfo = get(fieldList, field)
  if (station && fieldInfo) {
    let level = get(present, [station.stationId, field])

    if (isNumber(level)) {
      if (fieldInfo?.decimal) {
        level = round(level, fieldInfo.decimal)
        return level.toFixed(fieldInfo.decimal)
      }
      return level.toFixed(1)
    }
    // TODO: 欠測時の扱い、ただし暫定対応 20220228 haramoto
    return get(fieldInfo, 'default', '')
  }
  return ''
}

export const getFetchTime = (
  present: {
    [key in string]: Present
  },
  station: StationGeometry
) => {
  if (!station) {
    return ''
  }

  return present[station.stationId]?.time
}
